import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { sendNotificationEmail } from '../api/requests';

type Props = {
  setIsValid: (value: boolean) => void;
};

export function CheckMapAPIKey({ setIsValid }: Props) {
  const VITE_GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
  const { t } = useTranslation();

  const [isValid, setLocalIsValid] = useState<boolean | null>(true);
  const [showContent, setShowContent] = useState<boolean>(false);

  useEffect(() => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=New+York&key=${VITE_GOOGLE_API_KEY}`;

    // Make a test request to the Geocoding API
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (
          data.error_message &&
          (data.error_message.toLowerCase().includes('invalid') ||
            data.error_message.toLowerCase().includes('you must use an api key'))
        ) {
          sendNotificationEmail(
            `${window.location.hostname}: Allurion Maps API Key Error`,
            'The Maps API key is invalid or missing. Please check the configuration.'
          );
          setIsValid(false);
          setLocalIsValid(false);
        } else {
          setIsValid(true);
          setLocalIsValid(true);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error:', error);
        setIsValid(false);
        setLocalIsValid(false);
      });

    const timer = setTimeout(() => {
      setShowContent(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  if (!showContent) return null;

  return (
    <>
      <p
        className={`px-[16px] py-[40px] text-center text-primary text-red-600 ${
          isValid ? 'hidden' : 'block'
        }`}
      >
        {t('We are experiencing an issue with loading the Clinics Map. Please try again later.')}
      </p>
    </>
  );
}
